<script>
import { mapActions } from 'vuex';
import { result } from 'lodash';
import RbxRemoteCombobox from '@/shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '@/shared/reybex/RbxRemoteComboboxMultiple';
import validatorMixin from '@/mixins/validator';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'NewTaskDialog',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
  },
  mixins: [snackbarMixin, validatorMixin],
  props: {
    parentResource: {
      type: String,
      required: false,
      default: '',
    },
    parentResourceId: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      rules: {
        name: { required: true },
        priority: { required: true },
        status: { required: true },
      },
      baseFormData: {
      },
      formData: {},
      priorityOptions: [{ id: 3, text: 'Sehr hoch' }, { id: 2, text: 'Hoch' }, { id: 1, text: 'Normal' }, { id: 0, text: 'Niedrig' }],
      statusOptions: [{ id: 0, text: 'Offen' }, { id: 1, text: 'In Bearbeitung' }, { id: 2, text: 'Geschlossen' }],
      showDateMenu: false,
      showDateMenu2: false,
    };
  },
  created() {
    this.formData.status = 0;
  },
  mounted() {
    this.visible = true;
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    ...mapActions('taskList', ['saveTask', 'addTask']),
    ...mapActions('taskList', { fetchData: 'fetchTaskList' }),
    submit() {
      if (!this.validateForm()) return false;

      this.isLoading = true;

      if (this.parentResource && this.parentResourceId) {
        this.formData[this.parentResource] = { id: this.parentResourceId };
      }

      return this.addTask(this.formData)
        .then(() => {
          this.showSuccessMessage('Die Aufgabe wurde angelegt.');
          this.fetchData({
            parentResource: this.parentResource, parentResourceId: this.parentResourceId,
          });
          this.close();
        })
        .catch((response) => {
          const message = result(response, 'data.data.error', 'Es ist ein Fehler aufgetreten.');
          this.showErrorMessage(message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    close() {
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <v-dialog
    v-model="visible"
    persistent
    max-width="1000px"
  >
    <v-card>
      <v-card-title class="title pa-3">
        Neue Aufgabe
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>
            <v-flex md12>
              <v-layout row wrap>
                <v-flex md6>
                  <v-text-field
                    v-model="formData.name"
                    label="Bezeichnung"
                    class="caption"
                    height="22"
                    :error-messages="validationErrorMessages.name"
                  />
                </v-flex>

                <v-flex md6>
                  <rbx-remote-combobox
                    v-model="formData.user"
                    :selected="formData.user"
                    searchable
                    domain="User"
                    label="Benutzer"
                  />
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex md12>
              <v-layout row wrap>
                <v-flex md6>
                  <v-select
                    :items="priorityOptions"
                    v-model="formData.priority"
                    item-value="id"
                    item-text="text"
                    label="Priorität"
                    :error-messages="validationErrorMessages.priority"
                  />
                </v-flex>

                <v-flex md6>
                  <v-select
                    :items="statusOptions"
                    v-model="formData.status"
                    item-value="id"
                    item-text="text"
                    label="Status"
                    :error-messages="validationErrorMessages.status"
                  />
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex md12>
              <v-textarea
                v-model="formData.description"
                label="Beschreibung"
                class="caption"
                height="66"
              />
            </v-flex>

            <v-flex md6>
              <v-menu
                ref="showDateMenu"
                :close-on-content-click="false"
                v-model="showDateMenu"
                :return-value.sync="formData.deadline"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="formData.deadline"
                  :selected="formData.deadline"
                  label="Beginn"
                  prepend-icon="event"
                  readonly
                  day-format
                  height="22"
                  class="caption"
                />

                <v-date-picker
                  v-model="formData.deadline"
                  no-title scrollable
                  @input="$refs.showDateMenu.save(formData.deadline)"
                />
              </v-menu>
            </v-flex>

            <v-flex md6>
              <v-menu
                ref="showDateMenu2"
                :close-on-content-click="false"
                v-model="showDateMenu2"
                :return-value.sync="formData.resubmission"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="formData.resubmission"
                  :selected="formData.resubmission"
                  label="Wiedervorlage"
                  prepend-icon="event"
                  readonly
                  day-format
                  height="22"
                  class="caption"
                />

                <v-date-picker
                  v-model="formData.resubmission"
                  no-title scrollable
                  @input="$refs.showDateMenu2.save(formData.resubmission)"
                />
              </v-menu>
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn @click.native="close"
               color="red"
               flat>
          Schließen
        </v-btn>

        <v-btn @click.native="submit"
               color="blue"
               :loading="isLoading"
               flat>
          Speichern
        </v-btn>

      </v-card-actions>
    </v-card>

  </v-dialog>
</template>
